import React from "react";

export default function Dollor() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32"
    >
      <path
        fill="#76A9FA"
        d="M13.805 11.869c.248-.165.554-.314.907-.428v2.717c-.32-.1-.625-.244-.907-.427-.58-.387-.693-.749-.693-.931 0-.183.112-.544.693-.931zm4.107 8.69V17.84c.352.114.66.263.908.428.582.388.692.748.692.93 0 .183-.112.545-.692.932a3.688 3.688 0 01-.908.427z"
      ></path>
      <path
        fill="#76A9FA"
        fillRule="evenodd"
        d="M16.313 28.8a12.8 12.8 0 100-25.6 12.8 12.8 0 000 25.6zm1.6-20.8a1.6 1.6 0 00-3.2 0v.147c-.956.17-1.868.53-2.682 1.06-1.155.768-2.118 2.008-2.118 3.593 0 1.584.963 2.824 2.118 3.594.768.512 1.686.872 2.682 1.059v3.106c-.626-.204-1.088-.508-1.35-.807a1.6 1.6 0 10-2.415 2.096c.9 1.039 2.26 1.722 3.765 2.005V24a1.6 1.6 0 003.2 0v-.147a7.255 7.255 0 002.681-1.06c1.155-.767 2.119-2.007 2.119-3.593 0-1.584-.963-2.824-2.119-3.593a7.255 7.255 0 00-2.681-1.06v-3.105c.625.203 1.088.507 1.349.806a1.6 1.6 0 102.417-2.096c-.9-1.038-2.26-1.721-3.766-2.005V8z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
